module.exports = __webpack_public_path__ + "static/media/detail_hip_xray_pg1.8a4b38c0.png";